import { memo } from 'react';
import Icons from 'assets/icons/icons_sprite.svg';

type AppUseIconPropsType = {
  name: string;
  className?: string;
  color?: string;
  width?: string;
  height?: string;
};

const AppUseIcon = ({ name, color = '#414141', width = '21', height = '21', className = '' }: AppUseIconPropsType) => {
  return (
    <>
      <svg className={`icon ${className}`} width={width} viewBox={`0 0 ${width} ${height}`} fill={color} data-testid='app-use-icon'>
        <use xlinkHref={Icons + `#${name}`} href={Icons + `#${name}`} />
      </svg>
    </>
  );
};

export default memo(AppUseIcon);
